import EkomApi from "../api/EkomApi";
import { useFetch } from './useFetch'

export const useCountIncoming = () => {
  return useFetch<number>(EkomApi.getCountIncoming);
};